import { AdminLayoutWithAuth } from "@/components/layout/AdminLayout/AdminLayout";
import { LoginLayout } from "@/components/layout/LoginLayout/LoginLayout";
import AdminUser from "@/pages/admin-user/AdminUser";
import AdminUserCreate from "@/pages/admin-user/AdminUserCreate";
import AdminUserDetail from "@/pages/admin-user/AdminUserDetail";
import AdminUserEdit from "@/pages/admin-user/AdminUserEdit";
import Login from "@/pages/auth/Login";
import Logout from "@/pages/auth/Logout";
import Recover from "@/pages/auth/Recover";
import RecoverComplete from "@/pages/auth/RecoverComplete";
import Register from "@/pages/auth/Register";
import ResetPassword from "@/pages/auth/ResetPassword";
import ResetPasswordComplete from "@/pages/auth/ResetPasswordComplete";
import Home from "@/pages/home/Home";
import MasterDataDetail from "@/pages/master-data/MasterDataDetail";
import MasterDataList from "@/pages/master-data/MasterDataList";
import PageNotFound from "@/pages/PageNotFound";
import ServerErrorPage from "@/pages/ServerErrorPage";
import { AppRoutes } from "@/routes/config";
import { RouteObject } from "react-router-dom";
import { Layout } from "@/features/rso/layout/Layout";
import CanceledContractList from "@/pages/match/CanceledContractList";
import TrialCancelledList from "@/pages/match/TrialCancelledList";
import TrialMatchList from "@/pages/match/TrialMatchList";
import DuringContractList from "@/pages/match/DuringContractList";
import MatchDetail from "@/pages/match/MatchDetail";
import MatchEdit from "@/pages/match/MatchEdit";
import MatchUserCreate from "@/pages/match/match-user/MatchUserCreate";
import MatchUserEdit from "@/pages/match/match-user/MatchUserEdit";
import MatchCreate from "@/pages/match/MatchCreate";
import { SettingLayout } from "@/features/system-setting/layout/SettingLayout";
import EmailSetting from "@/pages/system-setting/EmailSetting";
import MaintenanceSetting from "@/pages/system-setting/MaintenanceSetting";
import Information from "@/pages/information/Information";
import InformationCreate from "@/pages/information/InformationCreate";
import InformationEdit from "@/pages/information/InformationEdit";
import Chat from "@/pages/chat/Chat";
import LearningContent from "@/pages/learning-content/LearningContent";
import IndustryDetail from "@/pages/learning-content/IndustryDetail";
import SubjectCreate from "@/pages/learning-content/SubjectCreate";
import SubjectEdit from "@/pages/learning-content/SubjectEdit";
import IndustryCreate from "@/pages/learning-content/IndustryCreate";
import IndustryEdit from "@/pages/learning-content/IndustryEdit";
import SubjectDetail from "@/pages/learning-content/SubjectDetail";
import ExamCreate from "@/pages/learning-content/ExamCreate";
import ExamEdit from "@/pages/learning-content/ExamEdit";
import WordDetail from "@/pages/learning-content/WordDetail";
import MockExamDetail from "@/pages/learning-content/MockExamDetail";
import MockExamEdit from "@/pages/learning-content/MockExamEdit";
import WordEdit from "@/pages/learning-content/WordEdit";
import CompanyDuringContractList from "@/pages/company/DuringContractList";
import CompanyCanceledContractList from "@/pages/company/CanceledContractList";
import TrialCompanyList from "@/pages/company/TrialCompanyList";
import CompanyTrialCancelledList from "@/pages/company/TrialCancelledList";
import CompanyCreate from "@/pages/company/CompanyCreate";
import CompanyDetail from "@/pages/company/CompanyDetail";
import CompanyEdit from "@/pages/company/CompanyEdit";
import CompanyUserCreate from "@/pages/company/company-user/CompanyUserCreate";
import CompanyUserEdit from "@/pages/company/company-user/CompanyUserEdit";
import RegisterComplete from "@/pages/auth/RegisterComplete";
import { CompanyLayout } from "@/features/company/layout/CompanyLayout";

export const routes: RouteObject[] = [
  {
    element: <LoginLayout />,
    children: [
      { path: AppRoutes.recover, element: <Recover /> },
      {
        path: AppRoutes.recoverComplete,
        element: <RecoverComplete />,
      },
      { path: AppRoutes.resetPassword, element: <ResetPassword /> },
      {
        path: AppRoutes.resetPasswordComplete,
        element: <ResetPasswordComplete />,
      },
      { path: AppRoutes.login, element: <Login /> },
      {
        path: AppRoutes.registerComplete,
        element: <RegisterComplete />,
      },
      { path: AppRoutes.register, element: <Register /> },
    ],
  },
  {
    element: <AdminLayoutWithAuth />,
    children: [
      {
        path: AppRoutes.home,
        element: <Home />,
      },
      {
        // path: AppRoutes.rso,
        element: <Layout />,
        children: [
          { path: AppRoutes.duringContractList, element: <DuringContractList /> },
          { path: AppRoutes.canceledContractList, element: <CanceledContractList /> },
          { path: AppRoutes.trialRsoList, element: <TrialMatchList /> },
          { path: AppRoutes.trialCancelledList, element: <TrialCancelledList /> },
        ],
      },
      { path: AppRoutes.rsoCreate, element: <MatchCreate /> },
      { path: AppRoutes.rsoDetail, element: <MatchDetail /> },
      { path: AppRoutes.rsoEdit, element: <MatchEdit /> },
      { path: AppRoutes.rsoUserCreate, element: <MatchUserCreate /> },
      { path: AppRoutes.rsoUserEdit, element: <MatchUserEdit /> },

      {
        // Company Management routes - using same Layout as RSO for now
        element: <CompanyLayout />,
        children: [
          { path: AppRoutes.companyDuringContractList, element: <CompanyDuringContractList /> },
          { path: AppRoutes.companyCanceledContractList, element: <CompanyCanceledContractList /> },
          { path: AppRoutes.companyTrialList, element: <TrialCompanyList /> },
          { path: AppRoutes.companyTrialCancelledList, element: <CompanyTrialCancelledList /> },
        ],
      },
      { path: AppRoutes.companyCreate, element: <CompanyCreate /> },
      { path: AppRoutes.companyDetail, element: <CompanyDetail /> },
      { path: AppRoutes.companyEdit, element: <CompanyEdit /> },
      { path: AppRoutes.companyUserCreate, element: <CompanyUserCreate /> },
      { path: AppRoutes.companyUserEdit, element: <CompanyUserEdit /> },

      { path: AppRoutes.adminUser, element: <AdminUser /> },
      { path: AppRoutes.adminUserCreate, element: <AdminUserCreate /> },
      { path: AppRoutes.adminUserDetail, element: <AdminUserDetail /> },
      { path: AppRoutes.adminUserEdit, element: <AdminUserEdit /> },

      { path: AppRoutes.information, element: <Information /> },
      { path: AppRoutes.informationCreate, element: <InformationCreate /> },
      { path: AppRoutes.informationEdit, element: <InformationEdit /> },

      { path: AppRoutes.chat, element: <Chat /> },
      { path: AppRoutes.chatDetail, element: <Chat /> },
      {
        element: <SettingLayout />,
        children: [
          { path: AppRoutes.emailSetting, element: <EmailSetting /> },
          { path: AppRoutes.maintenanceSetting, element: <MaintenanceSetting /> },
        ],
      },

      { path: AppRoutes.learningContent, element: <LearningContent /> },
      { path: AppRoutes.industryCreate, element: <IndustryCreate /> },
      { path: AppRoutes.industryDetail, element: <IndustryDetail /> },
      { path: AppRoutes.industryEdit, element: <IndustryEdit /> },
      { path: AppRoutes.masterData, element: <MasterDataList /> },
      { path: AppRoutes.learningContentSubjectCreate, element: <SubjectCreate /> },
      { path: AppRoutes.learningContentSubjectEdit, element: <SubjectEdit /> },
      { path: AppRoutes.learningContentSubjectDetail, element: <SubjectDetail /> },
      { path: AppRoutes.learningContentWordDetail, element: <WordDetail /> },
      { path: AppRoutes.learningContentWordEdit, element: <WordEdit /> },
      { path: AppRoutes.learningContentMockExamCreate, element: <MockExamEdit /> },
      { path: AppRoutes.learningContentMockExamEdit, element: <MockExamEdit /> },
      { path: AppRoutes.learningContentMockExamDetail, element: <MockExamDetail /> },
      { path: AppRoutes.learningContentExamCreate, element: <ExamCreate /> },
      { path: AppRoutes.learningContentExamEdit, element: <ExamEdit /> },
      { path: AppRoutes.masterDataDetail, element: <MasterDataDetail /> },
    ],
  },
  { path: AppRoutes.logout, element: <Logout /> },
  { path: AppRoutes.serverErrorPage, element: <ServerErrorPage /> },
  { path: "*", element: <PageNotFound /> },
];
